import Dashboard from '@/views/dashboard'
import DashboardManagers from '@/views/dashboardManagers'
import { facilita } from "@/global"
import { storage } from '@/services/storage'

var routes =  [
    {
        path: '/',
        name: 'dashboard',
        component: Dashboard,
        meta: {
            title: (storage.get('client_name') || 'Facilita') + ' - Dashboard',
            protect: true,
            rules: {
                groups: [
                    'broker',
                ],
                redirect: { name: 'dashboard-managers' }
            }
        }
    },
    {
        path: '/',
        name: 'dashboard-managers',
        component: DashboardManagers,
        meta: {
            title: (storage.get('client_name') || 'Facilita') + ' - Dashboard',
            protect: true,
        }
    },
]


export { routes }